import * as Yup from 'yup';

export const forgotPasswordSchema = Yup.object().shape({
    username: Yup.string().email().max(128).required(),
});
